import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../components/navbar/navbar";
import MesPageBanner from "../components/mes-page-banner/mes-page-banner";

function getMesBannerTitle(pathname: string): string {
  if (pathname === "/mes-dashboard") return "Production Overview";
  if (pathname === "/mes-parts") return "Parts Catalog";
  if (pathname === "/mes-jobs") return "Jobs";
  if (pathname.startsWith("/mes-jobs/")) return "Job";
  if (pathname === "/mes-workflow") return "Workflow Templates";
  if (pathname === "/mes-operations") return "Process Definitions";
  if (pathname === "/mes-workcenter") return "Machines & Equipment";
  if (pathname === "/mes-operators") return "Operators & Personnel";
  if (pathname === "/mes-trurecipe/library") return "Recipe Library";
  if (pathname.startsWith("/mes-trurecipe/recipe/")) return "Recipe Library";
  if (pathname === "/mes-order") return "Production Orders";
  if (pathname.startsWith("/mes-order/order/")) return "Production Order";
  if (pathname === "/mes-order/cad-manufacturing") return "CAD → Manufacturing";
  if (pathname === "/mes-tasks") return "Tasks";
  if (pathname === "/mes-trurecipe/compare") return "Recipe Comparison";
  if (pathname === "/mes-trurecipe/guided") return "Guided Work Instructions";
  if (pathname === "/mes-trurecipe/digital-twin") return "Digital Twin — Should vs Is";
  return "";
}

/**
 * Shared shell: top nav + orange category strip + scrollable main column.
 * Page components render only their inner content (no duplicate Navbar / banner).
 */
export default function MesAppShell() {
  const { pathname } = useLocation();
  return (
    <>
      <Navbar />
      <div className="container-fluid clsRightSide clearfix clsScrollContent">
        <MesPageBanner title={getMesBannerTitle(pathname)} />
        <Outlet />
      </div>
    </>
  );
}
